import { FC } from 'react'
import styled, { css } from 'styled-components'
import { useTranslation } from 'next-i18next'
import { CSSTransition } from 'react-transition-group'

import { poppins } from '@/components/common/fonts'

import { ResultProgress } from '../../../common/components/ResultProgress'

import { Area } from '../styles'

import { VideoPlayer } from './VideoPlayer'

type ResultAreaProps = {
  videoSrc?: string
  /**
   * 0 ~ 100
   */
  progress?: number

  isGenerated?: boolean
  isGenerating?: boolean

  className?: string
}

/**
 * 프로그레스 시간: 5분\
 * unit: ms
 */
const PROGRESS_DURATION = 1000 * 60 * 5
/**
 * 페이드 딜레이 1s\
 * unit: ms
 */
const FADE_DELAY = 1000
/**
 * 페이드 시간: 0.2s\
 * unit: ms
 */
const FADE_DURATION = 200

export const ResultArea: FC<ResultAreaProps> = ({
  videoSrc,

  isGenerated,
  isGenerating,

  className,
}) => {
  const { t } = useTranslation('common')

  return (
    <ResultAreaContainer className={className}>
      <ResultPreview>
        {isGenerated && !!videoSrc ? (
          <VideoPlayer src={videoSrc} />
        ) : (
          <ResultPreviewEmpty>{t('Generate a video!')}</ResultPreviewEmpty>
        )}
      </ResultPreview>

      <CSSTransition
        in={isGenerating}
        timeout={FADE_DURATION + FADE_DELAY}
        classNames="fade"
        mountOnEnter
        unmountOnExit
        css={css`
          &.fade-exit {
            opacity: 1;
          }

          &.fade-exit-active {
            opacity: 0;
            transition: opacity ${FADE_DURATION}ms ${FADE_DELAY}ms;
          }
        `}
      >
        {/* @ts-expect-error */}
        <ResultProgress
          duration={PROGRESS_DURATION}
          isGenerating={isGenerating}
        />
      </CSSTransition>
    </ResultAreaContainer>
  )
}

const ResultAreaContainer = styled(Area)`
  grid-column: 2;
  grid-row: 1;

  border-bottom: 1px solid #f3f3f3;

  @media (max-width: ${({ theme }) => theme.screenMD}px) {
    grid-column: auto;
    grid-row: auto;
  }
`

const ResultPreview = styled.div`
  display: flex;
  justify-content: stretch;

  margin-bottom: 13px;

  aspect-ratio: 342 / 264;
`

const ResultPreviewEmpty = styled.div`
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #eef6ff;

  font-family: ${poppins.string};
  font-size: 16px;
  line-height: 24px;
  color: #4276ee;
`
